import { render, staticRenderFns } from "./Mails.list.vue?vue&type=template&id=90601c48&"
import script from "./Mails.list.vue?vue&type=script&lang=js&"
export * from "./Mails.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports